import type { GetLearningAttemptsQuery } from "api/generated";
import { SessionHistory } from "features/History/Session";
import { TutoringHistory } from "features/History/Tutoring";

interface HistoryListProps {
  data: GetLearningAttemptsQuery["learningAttempts"];
  onLoadMore: () => void;
}

export const HistoryList = ({ data }: HistoryListProps) => (
  <>
    <div className="d-flex gap-3 flex-column">
      {data?.map(item => {
        if (item.session) {
          return <SessionHistory key={item.id} session={item.session} date={item.dateTested} />;
        } else if (item.tutoringSnapshot) {
          return <TutoringHistory key={item.id} tutoring={item.tutoringSnapshot} date={item.dateTested} />;
        }

        return null;
      })}
    </div>
  </>
);
